export const MarketplaceIcon = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt"
    height="512.000000pt"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="currentcolor"
      stroke="currentcolor"
    >
      <path
        d="M375 4957 c-94 -32 -158 -88 -197 -172 -34 -74 -32 -191 4 -260 31
-60 86 -114 148 -146 37 -20 60 -24 130 -24 70 0 93 4 130 24 61 32 116 86
148 146 23 43 27 62 27 135 0 97 -19 146 -84 213 -75 80 -209 116 -306 84z"
      />
      <path
        d="M4585 4961 c-84 -22 -163 -87 -206 -171 -20 -37 -24 -60 -24 -130 0
-73 4 -92 27 -135 32 -60 87 -114 148 -146 37 -20 60 -24 130 -24 73 0 92 4
135 27 111 59 170 155 169 278 0 128 -66 231 -178 281 -53 23 -152 33 -201 20z"
      />
      <path
        d="M2485 4561 c-84 -22 -163 -88 -206 -171 -20 -37 -24 -60 -24 -130 0
-73 4 -92 27 -135 32 -60 87 -114 148 -146 37 -20 60 -24 130 -24 70 0 93 4
130 24 61 32 116 86 148 146 23 43 27 62 27 135 0 70 -4 93 -24 130 -55 106
-148 169 -259 175 -37 2 -80 1 -97 -4z"
      />
      <path
        d="M791 4344 l-54 -56 564 -564 564 -563 53 50 53 51 -450 456 c-247
252 -501 507 -563 569 l-113 112 -54 -55z"
      />
      <path
        d="M3714 3835 c-308 -311 -560 -569 -560 -573 -1 -4 22 -28 50 -54 l52
-47 563 563 564 564 -55 56 -55 57 -559 -566z"
      />
      <path d="M2482 3638 l3 -163 75 0 75 0 3 163 2 162 -80 0 -80 0 2 -162z" />
      <path
        d="M2370 3299 c-269 -69 -482 -283 -550 -553 -27 -107 -27 -265 0 -372
86 -340 386 -574 737 -574 129 0 224 20 328 70 208 99 359 283 415 504 27 107
27 265 0 372 -69 274 -297 498 -567 558 -101 22 -268 20 -363 -5z"
      />
      <path
        d="M780 2861 c-86 -28 -160 -91 -201 -171 -19 -37 -23 -61 -23 -130 0
-72 4 -92 26 -135 31 -60 87 -114 148 -146 37 -20 60 -24 130 -24 70 0 93 4
130 24 61 32 116 86 148 146 23 43 27 62 27 135 0 70 -4 93 -24 130 -56 108
-151 171 -266 176 -38 2 -81 0 -95 -5z"
      />
      <path
        d="M4180 2861 c-86 -28 -159 -90 -201 -171 -20 -37 -24 -60 -24 -130 0
-73 4 -92 27 -135 32 -60 87 -114 148 -146 37 -20 60 -24 130 -24 73 0 92 4
135 27 111 59 170 154 170 278 0 124 -60 221 -170 277 -53 28 -166 40 -215 24z"
      />
      <path d="M1320 2555 l0 -75 163 2 162 3 3 73 3 72 -166 0 -165 0 0 -75z" />
      <path d="M3472 2558 l3 -73 163 -3 162 -2 0 75 0 75 -165 0 -166 0 3 -72z" />
      <path
        d="M1301 1396 l-564 -564 55 -56 55 -57 559 566 c308 312 559 570 559
573 0 4 -23 28 -51 54 l-50 47 -563 -563z"
      />
      <path
        d="M3202 1908 l-54 -51 234 -236 c128 -130 381 -385 563 -568 l329 -332
55 55 54 56 -564 564 -564 563 -53 -51z"
      />
      <path
        d="M2487 1644 c-4 -4 -7 -79 -7 -166 l0 -158 80 0 80 0 -2 163 -3 162
-70 3 c-39 1 -74 0 -78 -4z"
      />
      <path
        d="M2480 1161 c-86 -28 -159 -90 -201 -171 -20 -37 -24 -60 -24 -130 0
-73 4 -92 27 -135 59 -111 154 -170 278 -170 124 0 219 59 278 170 23 43 27
62 27 135 0 70 -4 93 -24 130 -56 108 -151 171 -266 176 -38 2 -81 0 -95 -5z"
      />
      <path
        d="M380 761 c-86 -28 -160 -91 -201 -171 -33 -64 -33 -184 -1 -256 29
-64 92 -126 157 -156 70 -32 180 -32 250 0 63 29 119 83 153 147 23 43 27 62
27 135 0 70 -4 93 -24 130 -56 108 -151 171 -266 176 -38 2 -81 0 -95 -5z"
      />
      <path
        d="M4580 761 c-86 -28 -159 -90 -201 -171 -20 -37 -24 -60 -24 -130 0
-73 4 -92 27 -135 32 -60 87 -115 148 -146 64 -33 184 -33 255 -1 65 30 128
92 157 156 32 72 32 192 -1 256 -55 107 -151 171 -266 176 -38 2 -81 0 -95 -5z"
      />
    </g>
  </svg>
)
